import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  StatusFormatter,
  columnsCreateVehicle,
  columnsCreateVehicleInv,
  formLabelsTheme,
  formatDate,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";
import paginationFactory from "react-bootstrap-table2-paginator";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import {
  addBookingVehicle,
  fetchBookingPartyAll,
  fetchBookingPartyAllFilter,
  fetchBookingVehicle,
  fetchIdBooking,
  selectBookingPartyAll,
  selectBookingPartyAllFilter,
  selectIdBooking,
} from "./bookingSlice";
import { Autocomplete } from "@material-ui/lab";
import { FormHelperText } from "@material-ui/core";
import {
  fetchInventory,
  selectInventory,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
} from "../inventory/inventorySlice";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ModalCreateVehicle = ({
  isOpen,
  setShow,
  formValues,
  setFormValues,
  setFields,
  fields,
  getData,
  setGetData,
  selectedRows,
  setSelectedRows,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectInventory);
  const dataId = useSelector(selectIdBooking);
  const dataPartyAll = useSelector(selectBookingPartyAllFilter);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const [tableData, setTableData] = useState(data);
  const paginationSet = useSelector(selectPagination);
  const { id } = useParams();

  // initial

  useEffect(() => {
    // Add number
    if (data !== null) {
      const pageBefore = pageSize * (pageNo - 1);
      const initData = data.map((item, index) => {
        return {
          ...item,
          no: index + 1 + pageBefore,
        };
      });
      setTableData(initData);
    }
  }, [data, pageSize, pageNo]);

  useEffect(() => {
    if (getData === true) {
      handleSearch();
      dispatch(
        fetchBookingPartyAllFilter({
          booking_id: id,
          party_code: "DEALER",
          party_setting: "DEALER",
          pageNo: 1,
          pageSize: -1,
        })
      );
      setGetData(false);
    }
  }, [getData]);

  const handleSearch = async () => {
    let params = {};
    fields.forEach((item) => {
      params[item.params] = item.value;
    });
    // params.is_booking = "N";
    params.book_pass = "Y";
    params.client_id = dataId.client;
    // params.status_vehicle = "5030";
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchInventory(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};
      fields.forEach((item) => {
        params[item.params] = item.value;
      });

      // params.is_booking = "N";
      params.book_pass = "Y";
      params.client_id = dataId.client;
      // params.status_vehicle = "5030";
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchInventory(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  // params

  const [typeOptions, setTypeOptions] = useState([
    {
      id: "1",
      value: "vin",
      label: "VIN",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "von",
      label: "VON",
      show: "Y",
      editor: "text",
    },

    {
      id: "4",
      value: "master_code",
      label: "Master Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "product_description",
      label: "Vehicle Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "model_code",
      label: "Model Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "model_name",
      label: "Model Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "color_code",
      label: "Color Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "color_name",
      label: "Color Name",
      show: "Y",
      editor: "text",
    },
  ]);

  // paket filter

  const [btnHide, setBtnHide] = useState(false);

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      values[i].remove = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      const filteredShow = result.filter((item) => item.show === "Y");
      if (filteredShow.length <= 1) {
        setBtnHide(true);
      } else {
        setBtnHide(false);
      }

      //   push new paramater
      values.push({
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      });
      setFields(values);
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });

    setTypeOptions(result);

    const filteredShow = result.filter((item) => item.show === "Y");
    if (filteredShow.length >= 1) {
      setBtnHide(false);
    } else {
      setBtnHide(true);
    }

    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    values[i].label = event.label;
    setFields(values);
  };

  // paket filter bawah

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Inbound Job",
      dataField: "inbound_job",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    // {
    //   text: "GR Date",
    //   dataField: "gr_date",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    //   headerAlign: "center",
    //   formatter: formatDate,
    // },
    {
      text: "Master Code",
      dataField: "master_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Vehicle Name",
      dataField: "product_description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "UOM",
      dataField: "vehicle_uom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Code",
      dataField: "model_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Color Code",
      dataField: "color_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Color Name",
      dataField: "color_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Engine No.",
      dataField: "engine_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Key No.",
      dataField: "key_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "Mileage",
      dataField: "mileage",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Accessories Installed",
      dataField: "accessories_installed",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: StatusFormatter,
      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "Accessories Installed Date",
      dataField: "accessories_installed_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,
      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "Location",
      dataField: "location_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "Is On Hold",
      dataField: "is_on_hold",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "Hold Reason",
      dataField: "hold_reason",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "RCI Date",
      dataField: "rci_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

      headerAlign: "center",
      formatter: formatDate,
      style: { minWidth: "200px" },
    },
    {
      text: "RCI Inspection Result",
      dataField: "rci_result",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "RCI Remarks",
      dataField: "rci_remark",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "PDI Date",
      dataField: "pdi_out_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      formatter: formatDate,
      style: { minWidth: "200px" },
    },
    {
      text: "PDI  Result",
      dataField: "pdi_results",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "PDI Remarks",
      dataField: "remark_pdiiout",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "Maintenance Date",
      dataField: "maintenance_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,
      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "Maintenance Remarks",
      dataField: "maintenance_remarks",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "Inspection Result",
      dataField: "inspection_result",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "Inspection Date",
      dataField: "inspection_Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,

      headerAlign: "center",
      style: { minWidth: "200px" },
    },
    {
      text: "Inspection Remarks",
      dataField: "inspection_remarks",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Is Damaged",
      dataField: "is_damaged",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "RFS",
      dataField: "rfs",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "Vehicle Status",
      dataField: "vehicle_status_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "Client",
      dataField: "client_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "60px" },
    },
  ];

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const handleClose = () => {
    setSelectedRows([]);
    setFormValues({
      party_id: {
        value: "",
        error: false,
        required: "N",
      },
      party_name: {
        value: "",
        error: false,
        required: "N",
      },
    });
    setFields([
      {
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      },
    ]);

    setShow(false);
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async (e) => {
    if (selectedRows.length < 1) {
      return showDialog("Please input Vehicle");
    }

    const params = selectedRows.map((item, index) => {
      return {
        booking_id: id,
        vehicle_id: item.vehicle_id,
        party_id: formValues.party_id.value,
      };
    });

    console.log(params, "params");

    try {
      const response = await dispatch(addBookingVehicle(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdBooking(id));

        await dispatch(
          fetchBookingVehicle({
            booking_id: id,
            pageNo: 1,
            pageSize: paginationSet,
          })
        );
        await handleClose();
        await window.scrollTo(0, 850);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  console.log(selectedRows, "selectedRows");

  const onSelectRow = {
    mode: "checkbox",
    onSelectAll: (status) => {
      if (status === true) {
        setSelectedRows([...tableData]);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows((prevSelectedRows) => [...prevSelectedRows, row]);
      } else {
        setSelectedRows((prevSelectedRows) => {
          const index = prevSelectedRows.findIndex(
            (selectedRow) => selectedRow.vehicle_id === row.vehicle_id
          );
          if (index > -1) {
            const newSelectedRows = [...prevSelectedRows];
            newSelectedRows.splice(index, 1);
            return newSelectedRows;
          }
          return prevSelectedRows;
        });
      }
    },
  };

  const handleChangeParty = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["party_id"]: {
        ...formValues["party_id"],
        value,
      },
    });
  };

  const partyOptions = dataPartyAll.map((e) => {
    return {
      value: e.party_id,
      label: e.party + "-" + e.party_name,
    };
  });

  const indexParty = partyOptions.findIndex(
    (obj) => obj.value === formValues.party_id.value
  );

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Add Vehicle
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {fields.map((field, idx) => {
            return (
              <div key={`${field}-${idx}`}>
                <Form.Group as={Row}>
                  <Form.Label column sm={2}>
                    {idx === 0 && <b>Search By</b>}
                  </Form.Label>

                  <Col sm={3}>
                    {fields[idx].add === "N" && (
                      <Select
                        // isClearable={true}
                        options={data_filter}
                        value={getValueType(field.params, typeOptions)}
                        placeholder="Select Field"
                        // onChange={handleTypeChange}
                        onChange={(e) => handleTypeChange(idx, e)}
                      />
                    )}
                    {fields[idx].add === "Y" && (
                      <Form.Control
                        type="text"
                        value={fields[idx].label}
                        disabled
                      />
                    )}
                  </Col>
                  <Col sm={3}>
                    {field.editor === "text" && (
                      <Form.Control
                        type="text"
                        placeholder="Enter text"
                        value={field.value || ""}
                        onChange={(e) => handleRemarkChange(idx, e)}
                      />
                    )}
                  </Col>
                  <Col sm={3} className=" m-0 p-0">
                    {fields[idx].remove === "Y" && (
                      <div
                        className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                        onClick={() => handleRemove(idx)}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-light">
                          <SVG
                            src={toAbsoluteUrl("/media/svg/icons/New/X.svg")}
                          />
                        </span>
                      </div>
                    )}

                    {btnHide === false && fields.length - 1 === idx && (
                      <Button
                        className="mr-3"
                        variant="outline-primary"
                        onClick={(e) => handleAdd(idx, e)}
                      >
                        Add
                      </Button>
                    )}

                    {fields.length - 1 === idx && (
                      <Button
                        className="mr-3"
                        variant="primary"
                        onClick={handleSearch}
                      >
                        Search
                      </Button>
                    )}
                  </Col>
                </Form.Group>
              </div>
            );
          })}
          <ThemeProvider theme={formLabelsTheme}>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <Autocomplete
                  disablePortal
                  name="party"
                  options={partyOptions}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  value={
                    partyOptions.find(
                      (option) => option.value === formValues.party_id.value
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    if (newValue === null) {
                      setFormValues({
                        ...formValues,
                        ["party_id"]: {
                          ...formValues["party_id"],
                          value: "",
                        },
                      });
                    } else {
                      setFormValues({
                        ...formValues,
                        ["party_id"]: {
                          ...formValues["party_id"],
                          value: newValue.value,
                        },
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <RedditTextField
                      className={classes.margin}
                      {...params}
                      label="Dealer"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      placeholder="Select"
                      name="party_id"
                    />
                  )}
                />
              </Col>
            </Row>
          </ThemeProvider>

          {data && data.length > 0 && (
            <BootstrapTable
              remote
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              keyField="vehicle_id"
              data={tableData}
              columns={columnsCreateVehicleInv}
              pagination={paginationFactory(options)}
              onTableChange={handleTableChange}
              selectRow={{
                ...onSelectRow,
                selected: selectedRows.map((row) => row.vehicle_id),
              }}
              hover
            >
              <PleaseWaitMessage entities={loading ? null : data} />
              <NoRecordsFoundMessage entities={loading ? null : data} />
            </BootstrapTable>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
